import { detectDevice } from "@decocms/blocks/sdk/detectDevice";
import { createStart } from "@tanstack/react-start";
import { CSEG_PARAM, segmentToken } from "./sdk/cdnSegment";

declare const __DECO_BUILD_HASH__: string | undefined;

// ─── Marcador de segmento na URL do /_serverFn ───────────────────────
//
// Anexa o segmento de cache à URL das chamadas de server function para que a
// chave do CDN da Cloudflare (que é a URL crua) volte a equivaler à chave que o
// Worker monta internamente. Ver src/sdk/cdnSegment.ts para o porquê.
//
// Só o cliente consegue fazer isso: o documento HTML inicial é navegação do
// browser, sem hook de JS. Aqui cobrimos as chamadas de dados de SPA e de
// prefetch — o volume criado pelo Speculation Rules (#155).
//
// SEGURANÇA: este valor é uma DICA, não fonte de verdade. O worker recalcula o
// segmento a partir do próprio request e só libera o CDN quando bate exatamente
// (src/worker-entry.ts). Marcador ausente, divergente, forjado ou de um build
// antigo apenas mantém o `no-store` de hoje — nunca produz resposta errada.

function segmentMarker(): string | null {
  if (typeof navigator === "undefined") return null;
  return segmentToken(
    // Só o device é observável no cliente. Se este request na verdade for de um
    // usuário logado / com região, o worker detecta na verificação e mantém o
    // no-store — o marcador simplesmente não confere.
    { device: detectDevice(navigator.userAgent) },
    typeof __DECO_BUILD_HASH__ !== "undefined" ? __DECO_BUILD_HASH__ : undefined,
  );
}

export const startInstance = createStart(() => ({
  serverFns: {
    fetch: (input, init) => {
      // serverFnFetcher sempre chama com a URL já montada como string
      // (start-client-core/src/client-rpc/serverFnFetcher.ts). Qualquer outra
      // forma cai no fetch normal.
      if (typeof input !== "string") return fetch(input, init);
      const marker = segmentMarker();
      if (!marker) return fetch(input, init);
      const sep = input.includes("?") ? "&" : "?";
      return fetch(`${input}${sep}${CSEG_PARAM}=${marker}`, init);
    },
  },
}));
